import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {MenuItem, Icon} from '../../../global';
import { NgIf, NgFor } from '@angular/common';
import { MatRipple } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { MatProgressBar } from '@angular/material/progress-bar';
import { AccessDirective } from '../../directives/has-access.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-side-nav-item',
    templateUrl: './side-nav-item.component.html',
    styleUrls: ['./side-nav-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, MatRipple, RouterLink, MatTooltip, SvgIconComponent, MatProgressBar, NgFor, AccessDirective, TranslatePipe]
})
export class SideNavItemComponent {
  @Input() public menuItem: MenuItem = null;
  @Input() public desktopClosed = false;
  @Input() public openedMenu: string = null;

  @Input() public selectedRoute: string = null;

  @Output() public toggle = new EventEmitter<string>();
  @Output() public route = new EventEmitter<string>();

  public readonly upgradeIcon = Icon.GRADE;

  openMenu() {
    if (this.menuItem) {
      if (this.menuItem.submenu) {
        if (this.openedMenu === this.menuItem?.name) {
          this.toggle.next(null);
        } else {
          this.toggle.next(this.menuItem?.name);
        }
      } else {
        this.clickedRoute(this.menuItem.route);
      }
    }
  }

  clickedRoute(route) {
    this.route.emit(route);
  }

  trackByLabel(item: any) {
    return item.name;
  }
}
